var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllPasswordresetyay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 117.091,
    viewBox: "0 0 380 117.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ill_passwordresetyay",
    transform: "translate(190 58.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ill_passwordresetyay-2",
    "data-name": "ill_passwordresetyay",
    transform: "translate(-190 -58.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120514",
    "data-name": "Path 120514",
    d: "M42.6,46.856A122.968,122.968,0,0,0,78.75,19.078c6.549-7.245,13.883-11.489,22.6-7.017h0A35.175,35.175,0,0,0,130.8,13.4l2.407-.975a102.372,102.372,0,0,1,78.065.19l16.315,6.726a35.074,35.074,0,0,0,20.811,1.875,35.112,35.112,0,0,1,17.619.874h0a46.626,46.626,0,0,0,34.542-3.1c14.415-7.233,24.877-11.121,42.611-1.115h0c16.34,9.221,32.325,17.024,35.695,36.645,3.116,18.151-9.855,32.186,4.129,43.4l7.955,6.333H31.212C14.771,69.656,28.4,53.949,42.6,46.856Z",
    transform: "translate(-15.822 -4.79)",
    fill: "#e0f0d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120515",
    "data-name": "Path 120515",
    d: "M396.213,84.913H18.747a1.267,1.267,0,0,1,0-2.533H396.213a1.267,1.267,0,1,1,0,2.533Z",
    transform: "translate(-17.48 15.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120516",
    "data-name": "Path 120516",
    d: "M224.847,58.434v53.314a3.8,3.8,0,0,1-3.8,3.8H133.9a3.8,3.8,0,0,1-3.8-3.8V58.434a3.8,3.8,0,0,1,3.8-3.8h11.4v-14.5c.025-18,14.731-33.2,32.718-32.87a32.2,32.2,0,0,1,31.6,32.135V54.6h11.4a3.8,3.8,0,0,1,3.825,3.838Zm-32.148-19a15.2,15.2,0,1,0-30.4,0v15.2h30.4Z",
    transform: "translate(12.552 -4.132)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120517",
    "data-name": "Path 120517",
    d: "M173.2,13.741C159.179,13.5,147.69,26.053,147.69,40.923V52.906h9.867v-15.2a15.2,15.2,0,0,1,30.4,0v15.2h9.867V40.315C197.875,25.812,186.843,13.981,173.2,13.741Z",
    transform: "translate(17.243 -2.404)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120518",
    "data-name": "Path 120518",
    d: "M130.1,48.46v53.314a3.8,3.8,0,0,0,3.8,3.8h87.147a3.8,3.8,0,0,0,3.8-3.8V48.46a3.8,3.8,0,0,0-3.8-3.8H133.9a3.8,3.8,0,0,0-3.8,3.8Z",
    transform: "translate(12.552 5.843)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5599",
    "data-name": "Rectangle 5599",
    width: 94.759,
    height: 12.413,
    transform: "translate(142.652 62.903)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120519",
    "data-name": "Path 120519",
    d: "M130.1,83.84v7.486a3.8,3.8,0,0,0,3.8,3.8h87.147a3.8,3.8,0,0,0,3.8-3.8V83.84Z",
    transform: "translate(12.552 16.291)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5600",
    "data-name": "Rectangle 5600",
    width: 94.759,
    height: 12.413,
    transform: "translate(142.652 75.317)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120520",
    "data-name": "Path 120520",
    d: "M130.1,48.46v8.6h94.747v-8.6a3.8,3.8,0,0,0-3.8-3.8H133.9a3.8,3.8,0,0,0-3.8,3.8Z",
    transform: "translate(12.552 5.843)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5601",
    "data-name": "Rectangle 5601",
    width: 94.759,
    height: 12.413,
    transform: "translate(142.652 87.717)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120521",
    "data-name": "Path 120521",
    d: "M224.967,55.267H130.233a.633.633,0,0,1,0-1.267h94.734a.646.646,0,0,1,.633.633A.633.633,0,0,1,224.967,55.267Z",
    transform: "translate(12.419 8.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120522",
    "data-name": "Path 120522",
    d: "M224.967,84.607H130.233a.633.633,0,1,1,0-1.267h94.734a.633.633,0,0,1,.633.633A.646.646,0,0,1,224.967,84.607Z",
    transform: "translate(12.419 16.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120523",
    "data-name": "Path 120523",
    d: "M152.514,65.017H130.233a.633.633,0,1,1,0-1.267h22.281a.633.633,0,1,1,0,1.267Z",
    transform: "translate(12.419 10.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120524",
    "data-name": "Path 120524",
    d: "M142.381,74.807H130.233a.633.633,0,0,1,0-1.267h12.147a.633.633,0,0,1,0,1.267Z",
    transform: "translate(12.419 13.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120525",
    "data-name": "Path 120525",
    d: "M207.057,65.017h-9.614a.633.633,0,0,1,0-1.267h9.614a.633.633,0,1,1,0,1.267Z",
    transform: "translate(30.341 10.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120526",
    "data-name": "Path 120526",
    d: "M210.257,74.807H185.443a.633.633,0,0,1,0-1.267h24.814a.633.633,0,0,1,0,1.267Z",
    transform: "translate(27.141 13.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120527",
    "data-name": "Path 120527",
    d: "M221.313,117.081H134.167a5.067,5.067,0,0,1-5.067-5.067V58.7a5.067,5.067,0,0,1,5.067-5.067H144.3V40.4a34.656,34.656,0,0,1,10.336-24.548,32.731,32.731,0,0,1,23.636-9.589,33.554,33.554,0,0,1,32.857,33.4V53.6h10.133a5.067,5.067,0,0,1,5.067,5.067v53.352a5.067,5.067,0,0,1-5.016,5.067ZM134.167,56.167a2.533,2.533,0,0,0-2.533,2.533v53.314a2.533,2.533,0,0,0,2.533,2.533h87.147a2.533,2.533,0,0,0,2.533-2.533V58.7a2.533,2.533,0,0,0-2.533-2.533H208.647V39.7a31.008,31.008,0,0,0-30.4-30.869A30.2,30.2,0,0,0,156.435,17.7a32.135,32.135,0,0,0-9.589,22.8V56.167Zm60.065,0H161.3V39.7a16.467,16.467,0,0,1,32.933,0Zm-30.4-2.533H191.7V39.7a13.933,13.933,0,0,0-27.867,0Z",
    transform: "translate(12.285 -4.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120528",
    "data-name": "Path 120528",
    d: "M158.7,46.193H142.387a1.267,1.267,0,0,1,0-2.533H158.7a1.267,1.267,0,0,1,0,2.533Z",
    transform: "translate(15.491 5.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120529",
    "data-name": "Path 120529",
    d: "M196.063,46.193H179.787a1.267,1.267,0,0,1,0-2.533h16.277a1.267,1.267,0,1,1,0,2.533Z",
    transform: "translate(25.464 5.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120530",
    "data-name": "Path 120530",
    d: "M45.184,24.713l1.343,9.918h.127l6.447-7.6,3.167,3.255-8.322,6.067v.127l9.905,1.545-1.267,4.294-9.272-3.889v.127l3.8,9.361-4.649,1.1-1.191-9.956h-.127l-6.7,7.613-2.939-3.331L43.778,37.4v-.127l-9.7-1.545,1.267-4.294,8.943,3.927v-.127l-3.61-9.475,4.509-1.077m0-2.533a2.382,2.382,0,0,0-.6,0l-4.5,1.077a2.533,2.533,0,0,0-1.773,3.382l1.533,3.927-3.445-1.507a2.407,2.407,0,0,0-1.026-.215,2.457,2.457,0,0,0-1.064.241,2.533,2.533,0,0,0-1.368,1.583l-1.267,4.294a2.533,2.533,0,0,0,2.027,3.2l3.8.608L34.088,41.2a2.535,2.535,0,0,0-.431,3.724L36.6,48.26a2.533,2.533,0,0,0,1.9.861h0a2.533,2.533,0,0,0,1.913-.861l3.1-3.5.532,4.459a2.532,2.532,0,0,0,2.521,2.229,3.04,3.04,0,0,0,.583,0l4.649-1.1a2.533,2.533,0,0,0,1.761-3.433L52,43.117l3.623,1.558a2.647,2.647,0,0,0,.988.2,2.723,2.723,0,0,0,1.089-.241,2.533,2.533,0,0,0,1.343-1.583l1.267-4.294a2.6,2.6,0,0,0-2.09-3.243l-4-.621,3.572-2.635a2.533,2.533,0,0,0,.317-3.8l-3.192-3.255A2.533,2.533,0,0,0,53.1,24.5h-.089a2.533,2.533,0,0,0-1.849.9l-2.875,3.433-.6-4.459a2.53,2.53,0,0,0-2.508-2.191Z",
    transform: "translate(-13.72 -0.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120531",
    "data-name": "Path 120531",
    d: "M237.313,30.023l4.6,1.267-3.939,9.88h.139l9.842-4.332,1.267,4.915-10.463,1.583v.127l8.36,6.941-3.458,3.2L237.123,45h-.139L235.6,55.344,231,54.077l3.927-9.6H234.8l-9.981,4.079-1.267-4.75,10.513-1.7v-.127l-8.373-6.65,3.369-3.395,6.739,8.677h.139l1.368-10.577m0-2.533a2.533,2.533,0,0,0-2.533,2.217l-.6,4.649-3.129-4.028a2.533,2.533,0,0,0-1.849-.975h-.152a2.533,2.533,0,0,0-1.811.76l-3.369,3.445a2.533,2.533,0,0,0,.228,3.8l4,3.179-5.067.811A2.53,2.53,0,0,0,221,44.514l1.267,4.75a2.533,2.533,0,0,0,1.33,1.621,2.445,2.445,0,0,0,1.115.266,2.407,2.407,0,0,0,.975-.2l4.484-1.875-1.545,3.99a2.462,2.462,0,0,0,1.685,3.357l4.6,1.267a2.355,2.355,0,0,0,.659.089,2.533,2.533,0,0,0,2.533-2.2l.583-4.37,2.939,3.876a2.533,2.533,0,0,0,1.8.988h.228a2.533,2.533,0,0,0,1.71-.671l3.395-3.192a2.533,2.533,0,0,0-.1-3.8L244.533,45l5.067-.735a2.533,2.533,0,0,0,2.077-3.154l-1.267-4.915a2.533,2.533,0,0,0-2.445-1.887,2.609,2.609,0,0,0-1.026.215l-4.383,1.925,1.685-4.256a2.472,2.472,0,0,0-1.7-3.344l-4.6-1.267a2.837,2.837,0,0,0-.646-.089Z",
    transform: "translate(36.768 1.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120532",
    "data-name": "Path 120532",
    d: "M85.2,60.373l.19,6.536h.076l4.674-4.585,1.837,2.318L86.2,68.087v.076L92.531,69.8l-1.089,2.7-5.713-3.141v.089l1.887,6.333-3.078.418L84.4,69.671H84.31l-4.839,4.56-1.7-2.343,5.738-3.319V68.48l-6.194-1.621,1.089-2.7,5.523,3.065V67.15l-1.786-6.333,3.053-.443m0-2.533h-.342l-2.989.418a2.521,2.521,0,0,0-2.09,3.192l.165.583-.279-.152a2.533,2.533,0,0,0-1.267-.329,2.685,2.685,0,0,0-.836.139,2.533,2.533,0,0,0-1.533,1.419L74.937,65.82a2.545,2.545,0,0,0,1.748,3.395l.317.076-.519.3a2.533,2.533,0,0,0-.785,3.673l1.685,2.343a2.533,2.533,0,0,0,1.811,1.039h.253a2.533,2.533,0,0,0,1.735-.684l.773-.735v.937A2.533,2.533,0,0,0,84.488,78.7h.342l3.053-.393a2.533,2.533,0,0,0,2.09-3.23l-.152-.507.355.19a2.457,2.457,0,0,0,1.267.317,2.711,2.711,0,0,0,.849-.139A2.609,2.609,0,0,0,93.8,73.5l1.039-2.787a2.47,2.47,0,0,0-1.723-3.357l-.494-.127.659-.393a2.533,2.533,0,0,0,.684-3.8l-1.837-2.318a2.533,2.533,0,0,0-1.862-.9h-.127a2.533,2.533,0,0,0-1.773.735l-.646.633V60.3A2.557,2.557,0,0,0,85.2,57.84Z",
    transform: "translate(-2.205 9.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120533",
    "data-name": "Path 120533",
    d: "M110.529,18.051l1.267,10.26.1.089,6.156-7.9,3.192,3.243-7.917,6.131.089.1,10.057,1.191-1.267,4.6-9.285-3.8-.1.089,3.471,9.614-4.332.95L110.77,32.479l-.089-.089-6.067,7.727-3.141-3.179,7.777-5.9-.089-.1L99.116,29.553l1.267-4.459,9.323,3.661.1-.089L106.2,19.28l4.383-1.191m0-2.533a2.939,2.939,0,0,0-.659.089l-4.383,1.178a2.533,2.533,0,0,0-1.71,3.357l1.609,4.18L101.3,22.738a2.462,2.462,0,0,0-3.319,1.685L96.71,28.881a2.533,2.533,0,0,0,2.09,3.192l4.18.57-3,2.267a2.59,2.59,0,0,0-.342,3.762l3.141,3.192a2.533,2.533,0,0,0,1.8.747h.127a2.533,2.533,0,0,0,1.849-.963l2.331-2.989.494,4.193a2.533,2.533,0,0,0,1.039,1.761,2.457,2.457,0,0,0,2.014.418l4.345-.937a2.56,2.56,0,0,0,1.837-3.357l-1.545-4.332,4.1,1.634A2.436,2.436,0,0,0,124.5,36.38l1.267-4.6a2.533,2.533,0,0,0-2.141-3.2l-4.091-.481,3.116-2.419a2.533,2.533,0,0,0,.253-3.8l-3-3.2a2.533,2.533,0,0,0-1.8-.747h-.152a2.533,2.533,0,0,0-1.849.975l-2.533,3.192-.557-4.4a2.533,2.533,0,0,0-2.533-2.217Z",
    transform: "translate(3.623 -1.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120534",
    "data-name": "Path 120534",
    d: "M284.69,21.654,286.083,32.5l.1.1,6.511-8.373,3.319,3.382L287.7,34.093v.089l10.627,1.267-1.368,4.864-9.817-4-.1.089,3.673,10.133-4.585,1-1.267-10.691-.1-.1-6.409,8.183-3.319-3.344,8.233-6.245-.1-.089-10.627-1.457,1.267-4.725,9.956,3.851.1-.089-3.8-9.931,4.636-1.267m0-2.533a2.939,2.939,0,0,0-.659.089l-4.636,1.267a2.475,2.475,0,0,0-1.71,3.319l1.811,4.737-4.687-1.837a2.533,2.533,0,0,0-3.357,1.672L270.2,33.067a2.552,2.552,0,0,0,2.1,3.192l4.763.646-3.458,2.622a2.533,2.533,0,0,0-.266,3.8l3.319,3.369a2.533,2.533,0,0,0,1.811.76h.139a2.533,2.533,0,0,0,1.849-.963l2.635-3.445.557,4.775a2.849,2.849,0,0,0,3.053,2.242l4.585-1a2.55,2.55,0,0,0,1.849-3.344l-1.8-4.978,4.712,1.925a2.748,2.748,0,0,0,.95.177A2.408,2.408,0,0,0,299.383,41l1.368-4.864a2.533,2.533,0,0,0-2.077-3.217l-4.687-.557,3.585-2.774a2.533,2.533,0,0,0,.253-3.8l-3.331-3.369a2.533,2.533,0,0,0-1.8-.76h-.152a2.533,2.533,0,0,0-1.849.975l-2.85,3.661-.646-5a2.533,2.533,0,0,0-2.533-2.217Z",
    transform: "translate(49.888 -0.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120535",
    "data-name": "Path 120535",
    d: "M271.764,65.835,270.193,79.49l.089.152L280.757,71.4l3.04,5.067-12.173,5.447.089.152,12.591,4.75-3.141,5.523L270.4,84.443l-.152.089,1.406,13.528-5.9-.165L267.5,84.443l-.089-.152-10.3,8.043-3.04-5.13,11.919-5.067-.089-.152-12.527-4.991,3.027-5.358,10.843,7.739.139-.089-1.647-13.275,6.029-.114m0-2.533h0l-6.029.114a2.565,2.565,0,0,0-2.47,2.85l.975,7.777-6.333-4.5a2.533,2.533,0,0,0-1.457-.469,2.787,2.787,0,0,0-.557,0,2.533,2.533,0,0,0-1.647,1.267l-3.027,5.358a2.533,2.533,0,0,0,1.267,3.6l7.081,2.825-6.447,2.774a2.533,2.533,0,0,0-1.178,3.61l3.04,5.067a2.533,2.533,0,0,0,1.71,1.191,2.8,2.8,0,0,0,.469,0,2.533,2.533,0,0,0,1.558-.545l5.573-4.345-.963,7.6a2.533,2.533,0,0,0,2.432,2.863l5.9.165h.076a2.533,2.533,0,0,0,2.533-2.8l-.836-8.069,6.333,4.623a2.533,2.533,0,0,0,1.495.494,2.609,2.609,0,0,0,2.2-1.267l3.027-5.5a2.533,2.533,0,0,0-1.267-3.61l-7.043-2.66,6.663-2.939A2.546,2.546,0,0,0,286,75.234l-3.04-5.067a2.533,2.533,0,0,0-1.71-1.267,2.925,2.925,0,0,0-.469,0,2.533,2.533,0,0,0-1.571.532l-5.8,4.585.9-7.853a2.531,2.531,0,0,0-2.521-2.825Zm0,5.067Z",
    transform: "translate(44.763 10.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120536",
    "data-name": "Path 120536",
    d: "M44.807,64.653a6.333,6.333,0,1,1-6.333,6.333,6.333,6.333,0,0,1,6.333-6.333m0-2.533a8.867,8.867,0,1,0,8.867,8.867,8.867,8.867,0,0,0-8.867-8.867Z",
    transform: "translate(-12.557 10.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120537",
    "data-name": "Path 120537",
    d: "M301.137,53.7a8.575,8.575,0,1,1-.051,0m0-2.533a11.1,11.1,0,1,0,11.1,11.1A11.1,11.1,0,0,0,301.086,51.17Z",
    transform: "translate(55.189 7.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120538",
    "data-name": "Path 120538",
    d: "M227.717,64.2a6.333,6.333,0,1,1-6.333,6.333,6.333,6.333,0,0,1,6.333-6.333m0-2.533a8.867,8.867,0,1,0,8.867,8.867,8.867,8.867,0,0,0-8.867-8.867Z",
    transform: "translate(36.219 10.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120539",
    "data-name": "Path 120539",
    d: "M256.2,11.763a3.179,3.179,0,1,1-3.179,3.179,3.179,3.179,0,0,1,3.179-3.179m0-2.533a5.713,5.713,0,1,0,5.713,5.713A5.713,5.713,0,0,0,256.2,9.23Z",
    transform: "translate(44.656 -3.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120540",
    "data-name": "Path 120540",
    d: "M113.141,56.6A4.155,4.155,0,1,1,109,60.758a4.155,4.155,0,0,1,4.142-4.155m0-2.533a6.678,6.678,0,1,1-.013,0Z",
    transform: "translate(6.243 8.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120541",
    "data-name": "Path 120541",
    d: "M72.411,10.993a4.142,4.142,0,1,1-2.933,1.218,4.155,4.155,0,0,1,2.933-1.218m0-2.533a6.688,6.688,0,1,0,6.675,6.688A6.688,6.688,0,0,0,72.411,8.46Z",
    transform: "translate(-4.619 -3.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120542",
    "data-name": "Path 120542",
    d: "M135.153,7.723a4.142,4.142,0,1,1-2.937,1.209,4.155,4.155,0,0,1,2.937-1.209m0-2.533a6.669,6.669,0,1,1-.013,0Z",
    transform: "translate(12.109 -4.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120543",
    "data-name": "Path 120543",
    d: "M206.308,21.423a4.155,4.155,0,1,1-4.142,4.155,4.155,4.155,0,0,1,4.142-4.155m0-2.533A6.688,6.688,0,1,0,213,25.578,6.688,6.688,0,0,0,206.308,18.89Z",
    transform: "translate(31.091 -1.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120544",
    "data-name": "Path 120544",
    d: "M78.4,37.093a5.345,5.345,0,1,1-5.345,5.333A5.345,5.345,0,0,1,78.4,37.093m0-2.533a7.9,7.9,0,1,0,.038,0Z",
    transform: "translate(-3.325 3.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120545",
    "data-name": "Path 120545",
    d: "M260.672,42.263a5.345,5.345,0,1,1-3.835,1.57,5.345,5.345,0,0,1,3.835-1.57m0-2.533a7.879,7.879,0,1,0,7.815,7.942,7.879,7.879,0,0,0-7.815-7.942Z",
    transform: "translate(45.253 4.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120546",
    "data-name": "Path 120546",
    d: "M55.742,29.685,47.42,35.816v.127l9.905,1.545-1.267,4.294-9.272-3.889v.127l3.8,9.361-4.649,1.1-1.191-9.956h-.127l-6.7,7.613-2.939-3.331,8.271-5.941v-.127L33.55,35.2,34.817,30.9l8.943,3.927V34.7l-3.61-9.475,4.509-1.077L46,34.093h.127l6.447-7.6Z",
    transform: "translate(-13.195 0.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120547",
    "data-name": "Path 120547",
    d: "M228.51,31.4l6.739,8.677h.139L236.756,29.5l4.6,1.267-3.939,9.88h.139l9.842-4.332,1.267,4.915L238.2,42.8v.127l8.36,6.941-3.458,3.2-6.536-8.613h-.139l-1.381,10.349-4.6-1.267,3.927-9.6h-.127l-9.981,4.079L223,43.269l10.513-1.7v-.127l-8.373-6.65Z",
    transform: "translate(37.325 1.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120548",
    "data-name": "Path 120548",
    d: "M91.435,64.121l-5.776,3.445v.076l6.333,1.634-1.089,2.7-5.713-3.141v.089l1.887,6.333L84,75.673l-.139-6.523h-.089l-4.839,4.56-1.7-2.343,5.738-3.319v-.089L76.78,66.338l1.089-2.7,5.523,3.053v-.076l-1.773-6.333,3.04-.443.19,6.536h.076L89.6,61.791Z",
    transform: "translate(-1.667 9.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120549",
    "data-name": "Path 120549",
    d: "M110,17.51l1.267,10.26.1.089,6.156-7.9,3.192,3.243L112.8,29.328l.089.1,10.057,1.191-1.267,4.6-9.285-3.8-.1.089,3.471,9.614-4.332.95-1.191-10.133-.089-.089-6.067,7.727L100.946,36.4l7.777-5.9-.089-.1L98.59,29.011l1.267-4.459,9.323,3.661.1-.089-3.61-9.386Z",
    transform: "translate(4.149 -1.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120550",
    "data-name": "Path 120550",
    d: "M284.177,21.11l1.393,10.843.1.1,6.511-8.373,3.319,3.382-8.309,6.485v.089L297.819,34.9l-1.368,4.864-9.817-4-.1.089,3.673,10.133-4.585.988-1.267-10.691-.1-.1-6.409,8.183-3.319-3.331,8.233-6.245-.1-.089L272.03,33.245,273.3,28.52l9.956,3.851.1-.089-3.8-9.931Z",
    transform: "translate(50.4 -0.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120551",
    "data-name": "Path 120551",
    d: "M271.242,65.31l-1.571,13.655.089.152,10.475-8.246,3.04,5.067L271.1,81.384l.089.152,12.591,4.75-3.141,5.523-10.767-7.891-.152.089,1.406,13.528-5.9-.165,1.748-13.452-.089-.152-10.3,8.043-3.04-5.13,11.919-5.067-.089-.152L252.85,76.469l3.027-5.358,10.843,7.739.139-.089-1.647-13.275Z",
    transform: "translate(45.285 11.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10410",
    "data-name": "Ellipse 10410",
    cx: 6.371,
    cy: 6.371,
    r: 6.371,
    transform: "translate(25.878 75.139)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10411",
    "data-name": "Ellipse 10411",
    cx: 8.55,
    cy: 8.55,
    r: 8.55,
    transform: "translate(347.776 61.295)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10412",
    "data-name": "Ellipse 10412",
    cx: 6.371,
    cy: 6.371,
    r: 6.371,
    transform: "translate(257.564 74.582)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10413",
    "data-name": "Ellipse 10413",
    cx: 3.179,
    cy: 3.179,
    r: 3.179,
    transform: "translate(297.616 8.158)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10414",
    "data-name": "Ellipse 10414",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(115.241 64.968)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10415",
    "data-name": "Ellipse 10415",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(63.663 7.195)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10416",
    "data-name": "Ellipse 10416",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(143.121 3.041)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10417",
    "data-name": "Ellipse 10417",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(233.257 20.407)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10418",
    "data-name": "Ellipse 10418",
    cx: 5.345,
    cy: 5.345,
    r: 5.345,
    transform: "translate(69.73 40.23)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10419",
    "data-name": "Ellipse 10419",
    cx: 5.345,
    cy: 5.345,
    r: 5.345,
    transform: "translate(300.529 46.791)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120552",
    "data-name": "Path 120552",
    d: "M202.767,78.355a29.133,29.133,0,1,1-58.267,0,18.66,18.66,0,0,1,.114-2.533,29.133,29.133,0,0,1,58.039,0C202.729,76.657,202.767,77.493,202.767,78.355Z",
    transform: "translate(16.392 7.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10420",
    "data-name": "Ellipse 10420",
    cx: 29.019,
    cy: 26.6,
    rx: 29.019,
    ry: 26.6,
    transform: "translate(161.006 56.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120553",
    "data-name": "Path 120553",
    d: "M174.167,49.763A29.133,29.133,0,1,1,145.033,78.9a29.133,29.133,0,0,1,29.133-29.133m0-2.533A31.667,31.667,0,1,0,205.833,78.9,31.667,31.667,0,0,0,174.167,47.23Z",
    transform: "translate(15.859 6.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120554",
    "data-name": "Path 120554",
    d: "M153.058,76.461a1.887,1.887,0,0,1,0-2.685l2.685-2.66a1.913,1.913,0,0,1,2.685,0l8.322,8.322,17.822-17.822a1.913,1.913,0,0,1,2.685,0l2.685,2.685a1.887,1.887,0,0,1,0,2.685l-21.85,21.863a1.887,1.887,0,0,1-2.685,0Z",
    transform: "translate(18.525 10.217)",
    fill: "#75b052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120555",
    "data-name": "Path 120555",
    d: "M184.2,61.592,166.382,79.414l-8.322-8.3a1.913,1.913,0,0,0-2.685,0l-1.495,1.495,11.159,11.172a1.887,1.887,0,0,0,2.685,0l20.659-20.659-1.495-1.495a1.913,1.913,0,0,0-2.685-.038Z",
    transform: "translate(18.893 10.216)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120556",
    "data-name": "Path 120556",
    d: "M167.017,90.906a3.154,3.154,0,0,1-2.242-.925l-12.35-12.35a3.167,3.167,0,0,1,0-4.471l2.685-2.7a3.243,3.243,0,0,1,4.484,0l7.423,7.41,16.923-16.923a3.243,3.243,0,0,1,4.484,0l2.685,2.685a3.167,3.167,0,0,1,0,4.471l-21.85,21.875a3.154,3.154,0,0,1-2.242.925Zm-9.665-18.835a.621.621,0,0,0-.443.19l-2.685,2.685a.633.633,0,0,0,0,.9l12.35,12.35a.646.646,0,0,0,.887,0L189.31,66.32a.633.633,0,0,0,0-.9l-2.685-2.685a.621.621,0,0,0-.443-.19.6.6,0,0,0-.443.19L167.916,80.583a1.267,1.267,0,0,1-1.8,0L157.8,72.261A.6.6,0,0,0,157.352,72.071Z",
    transform: "translate(18.259 9.946)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllPasswordresetyay);
export default __webpack_public_path__ + "static/media/ill_passwordresetyay.301f429ed807bad118410b72d1ecd8e4.svg";
export { ForwardRef as ReactComponent };